import api from './index';
import type { Task, UpdateTaskRequest, UpdateTaskResourcesRequest, UpdateTaskResourcesResponse } from '@/types/task';
import type { TasksResponse, GenerateTasksResponse } from '@/types/api';

/**
 * List tasks for the current user, optionally filtered by Set.
 */
export async function getTasks(params?: {
  status?: string;
  set_id?: string;
  limit?: number;
  cursor?: string;
}): Promise<TasksResponse> {
  const response = await api.get<TasksResponse>('/tasks', { params });
  return response.data;
}

/**
 * Get full task details.
 */
export async function getTask(taskId: string): Promise<Task> {
  const response = await api.get<Task>(`/tasks/${taskId}`);
  return response.data;
}

/**
 * Update task status (complete or ignore).
 */
export async function updateTask(
  taskId: string,
  data: UpdateTaskRequest,
): Promise<{ task_id: string; status: string; completed_at: string }> {
  const response = await api.patch(`/tasks/${taskId}`, data);
  return response.data;
}

/**
 * Update task resources (inline edits to email/text content).
 */
export async function updateTaskResources(
  taskId: string,
  data: UpdateTaskResourcesRequest,
): Promise<UpdateTaskResourcesResponse> {
  const response = await api.patch<UpdateTaskResourcesResponse>(`/tasks/${taskId}`, data);
  return response.data;
}

/**
 * Initiate task generation for the current user.
 */
export async function generateTasks(): Promise<GenerateTasksResponse> {
  const response = await api.post<GenerateTasksResponse>('/tasks/generate');
  return response.data;
}
